import React from 'react';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import {
  UPSERT_INCOME_FORM_ID,
  UpsertIncomeFormProps,
} from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { BusinessEmpty } from '../../tables/Business/Business.empty';
import { useBusinessForm } from './useBusinessForm';
import { BusinessFormFields } from './BusinessFormFields';

export type Props = UpsertIncomeFormProps;

export const BusinessForm = ({
  clientId,
  income,
  data,
  onSuccess,
  workflowProps,
  readOnly,
}: Props) => {
  const {
    data: { formBag, defaultShowAdvanced, mutationBag },
    actions: { onSubmit },
  } = useBusinessForm({ clientId, income, data, onSuccess, readOnly });

  const { BusinessAssetOption } = data.Options;

  if (BusinessAssetOption.length === 0) {
    return <BusinessEmpty clientId={clientId} workflowProps={workflowProps} />;
  }

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Business income form"
    >
      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <BusinessFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
